// @ts-nocheck
import React, { FC, useState } from 'react';
import { showBillRedirectState, userState, viewState } from '../../atoms';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { whichAuth as getAuth } from '../../getAuth';
import { copyOutline } from 'ionicons/icons';
import { viewProviders } from '../../constants/global';
import {
  IonButton,
  IonCol,
  IonContent,
  IonGrid,
  IonIcon,
  IonModal,
  IonRow,
  IonBadge,
  IonSpinner,
  useIonToast,
} from '@ionic/react';
import { Notification, AlertModal } from '../../components'
import { NotificationVariant } from "../../components/Notification/Notification.model";
import CallIcon from '../../assets/Notification/call.svg'
import EditIcon from '../../assets/Notification/edit.svg'
import MessageIcon from '../../assets/Notification/message.svg'
import './InvoiceRedirect.css'

const InvoiceRedirect: FC = () => {
  
  const user = useRecoilValue(userState);
  const setUser = useSetRecoilState(userState);
  const setView = useSetRecoilState(viewState);
  const showBillRedirect = useRecoilValue(showBillRedirectState);
  const setShowBillRedirect = useSetRecoilState(showBillRedirectState);
  
  const [option2InProgress, setOption2InProgress] = useState<boolean>(false);
  const [option3InProgress, setOption3InProgress] = useState<boolean>(false);
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const [present] = useIonToast();

  const showProviders = () => {
    setShowBillRedirect(false);
    setView(viewProviders);
  }

  const updateUserStatus = async (status) => {
    const token = await getAuth()?.currentUser?.getIdToken()
    try {
      const response = await fetch(user?._links?.self?.href, {
        method: 'PATCH',
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/merge-patch+json'
        },
        body: JSON.stringify({ status })
      })
      if (response.status === 200) {
        setUser({ ...user, status });
        setShowBillRedirect(false);
      } else {
        throw new Error('failed')
      }
    } catch (error) {
      setIsOpenModal(true)
    } finally {
      setOption2InProgress(false);
      setOption3InProgress(false);
    }
  }
  
  const option2 = () => {
    setOption2InProgress(true);
    updateUserStatus('CONTACTING_PROVIDERS');
  }
  
  const option3 = () => {
    setOption3InProgress(true);
    updateUserStatus('MANUAL_INVOICE_SEND');
  }
  
  return (
    <IonModal isOpen={showBillRedirect} onDidDismiss={() => setShowBillRedirect(false)} className="invoice-content">
      <IonContent>
        <IonGrid className="invoice-redirect-grid no-padding h-full">
          <IonRow>
            <IonCol size="12" className="invoice-icon">
              <Notification
                title="Option 1:  Sign authorisation"
                subTitle="Let us do the hard work for you. Digitally sign the authorisation and we will contact your providers and get them to send your bills directly to us"
                icon={EditIcon}
                className="small"
                variant={NotificationVariant.DEFAULT}>
                <IonButton onClick={() => showProviders()} className="item-dashboard-button">
                  Select <IonBadge color="light" className="preferred-badge">preferred</IonBadge>
                </IonButton>
              </Notification>
            </IonCol>
          </IonRow>
          
          <IonRow><IonCol className="invoice-redirect-or">OR</IonCol></IonRow>
          <IonRow>
            <IonCol size="12" className="invoice-icon">
              <Notification
                title="Option 2: Update email"
                subTitle={<>To redirect your bills, contact each of your providers and update your billing email address
                  to <a onClick={() => {navigator.clipboard.writeText(user.billingEmail); present('email address copied', 3000)}}>
                    {user.billingEmail} <IonIcon icon={copyOutline}/>
                  </a></>}
                icon={CallIcon}
                className="small"
                variant={NotificationVariant.DEFAULT}>
                <IonButton onClick={option2} className="item-dashboard-button">
                  { option2InProgress && <IonSpinner name="dots" /> }
                  Select
                </IonButton>
              </Notification>
            </IonCol>
          </IonRow>
          
          { user?.paymentOption !== 'SMOOV' &&
            <>
            <IonRow><IonCol className="invoice-redirect-or">OR</IonCol></IonRow>
            <IonRow>
              <IonCol size="12" className="invoice-icon">
                <Notification
                  title="Option 3: Forward bills"
                  subTitle={<>You can email individual invoices to us. Send your invoices
                    to <a onClick={() => {navigator.clipboard.writeText(user.billingEmail); present('email address copied', 3000)}}>
                      {user.billingEmail} <IonIcon icon={copyOutline}/>
                    </a></>}
                  icon={MessageIcon}
                  className="small"
                  variant={NotificationVariant.DEFAULT}>
                  <IonButton onClick={option3} className="item-dashboard-button">
                    { option3InProgress && <IonSpinner name="dots" /> }
                    Select
                  </IonButton>
                </Notification>
              </IonCol>
            </IonRow>
            </>
          }
          
          <IonRow>
            <IonCol size="12" className="invoice-button-wrapper">
              <IonButton onClick={() => setShowBillRedirect(false)} className="invoice-button-later">
                I’ll do it later
              </IonButton>
            </IonCol>
          </IonRow>
          
          <AlertModal
            isOpen={isOpenModal}
            title="Failed to select option"
            onClosed={() => setIsOpenModal(false)}
          />
        </IonGrid>
      </IonContent>
    </IonModal>
  );
}

export default InvoiceRedirect;
